import React, { useContext, useState, useEffect } from 'react';
import { GlobalSiteDataContext } from '../context';
import { useAwardsImages, useStaffImages, useStoreImages } from '../hooks';
import {
  Doctors,
  InteriorPhotos,
  LocationsBanner,
  NearbyStores,
  StoreDescription,
  StoreHero,
  ReviewsSlider,
  StaffPhotos,
  StoreStructuredData,
  SEO,
} from '../components';

function StoreTemplate({ pageContext }) {
  const siteData = useContext(GlobalSiteDataContext);
  const [currentStore, setCurrentStore] = useState(pageContext.currentStore);
  currentStore.storeImages = useStoreImages(
    siteData.currentMetro,
    currentStore
  );
  currentStore.staff = useStaffImages(
    siteData.currentMetro,
    pageContext.currentStore
  );
  currentStore.awards = useAwardsImages(
    siteData.currentMetro,
    pageContext.currentStore
  );

  useEffect(() => {
    // The remote store will take over
    setCurrentStore({
      ...currentStore,
      ...siteData.currentMetro.stores.find(
        (store) => store.marketingCity === currentStore.marketingCity
      ),
    });
  }, [siteData.currentMetro]);

  return (
    <main id='store-layout'>
      <StoreHero
        currentStore={currentStore}
        currentMetro={siteData.currentMetro}
      />
      {siteData.currentMetro.stores.length > 1 ||
      (siteData.currentMetro.borrowed_stores instanceof Array &&
        siteData.currentMetro.borrowed_stores.length > 0) ? (
        <NearbyStores
          currentStore={currentStore}
          currentMetro={siteData.currentMetro}
        />
      ) : (
        <LocationsBanner siteData={siteData} />
      )}
      <section className='full-section pb-0 light-blue-bg'>
        <StoreDescription currentStore={currentStore} />
        {/* {
          currentStore.staff.length > 0 && <StaffPhotos currentStore={currentStore} />
        } */}
        {<StaffPhotos currentStore={currentStore} />}
        <InteriorPhotos storeImages={currentStore.storeImages} />
        <span id='about-us'></span>
      </section>
      {currentStore.platforms.reviews.slide_token !== '' && (
        <ReviewsSlider currentStore={currentStore} />
      )}
    </main>
  );
}

export const Head = ({ location, pageContext }) => {
  return (
    <>
      <StoreStructuredData
        currentStore={pageContext.currentStore}
        currentMetro={pageContext.currentMetro}
      />
      <SEO
        location={location}
        origin={pageContext.currentMetro.origin}
        title={`About Us | Milan Laser Hair Removal | ${pageContext.currentStore.marketingCity} | ${pageContext.currentStore.stateAbbrev}`}
        description={`We provide state of the art laser hair removal treatments in a relaxing environment.`}
      />
    </>
  );
};

export default StoreTemplate;
